<template>
  <el-dialog
    :title="modalTitle"
    :visible.sync="visible"
    width="650px"
    center
    :close-on-click-modal="true"
    @close="close()"
    class="custom-dialog"
  >
    <el-card shadow="always">
      <el-form>
        <div class="sections-grid">
          <!-- Información General -->
          <div class="detail-section">
            <p class="dialog-p-subtitle">{{ i18nValues['generalInformation'] || 'Información General' }}</p>
            <el-form-item>
              <span class="label-text">{{ i18nValues['date'] || 'Fecha' }}:</span>
              <span class="value-text">{{ movement && movement.fecha ? formatDate(movement.fecha) : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['operation'] || 'Operación' }}:</span>
              <span class="value-text">{{ movement && movement.operacion ? movement.operacion : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['status'] || 'Estado' }}:</span>
              <span class="value-text">
                <el-tag
                  v-if="movement && movement.estado"
                  :type="getStatusType(movement.estado) || undefined"
                  :style="!getStatusType(movement.estado) ? { backgroundColor: getStatusColor(movement.estado), borderColor: getStatusColor(movement.estado), color: 'white' } : {}"
                  size="small"
                  effect="dark"
                >
                  {{ movement.estado }}
                </el-tag>
                <span v-else>-</span>
              </span>
            </el-form-item>
          </div>

          <!-- Ubicación -->
          <div class="detail-section">
            <p class="dialog-p-subtitle">{{ i18nValues['location'] || 'Ubicación' }}</p>
            <el-form-item>
              <span class="label-text">{{ i18nValues['field'] || 'Campo Origen' }}:</span>
              <span class="value-text">{{ movement && movement.campoOrigen ? movement.campoOrigen : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['plant'] || 'Planta Origen' }}:</span>
              <span class="value-text">{{ movement && movement.plantaOrigen ? movement.plantaOrigen : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['destination'] || 'Planta Destino' }}:</span>
              <span class="value-text">{{ movement && movement.plantaDestino ? movement.plantaDestino : "-" }}</span>
            </el-form-item>
          </div>

          <!-- Producto -->
          <div class="detail-section">
            <p class="dialog-p-subtitle">{{ i18nValues['product'] || 'Producto' }}</p>
            <el-form-item>
              <span class="label-text">{{ i18nValues['crop'] || 'Cultivo' }}:</span>
              <span class="value-text">{{ movement && movement.cultivoVariedad ? getCropName(movement.cultivoVariedad) : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['variety'] || 'Variedad' }}:</span>
              <span class="value-text">{{ movement && movement.cultivoVariedad ? getVarietyName(movement.cultivoVariedad) : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['brand'] || 'Brand' }}:</span>
              <span class="value-text">{{ movement && movement.brand ? movement.brand : "-" }}</span>
            </el-form-item>
          </div>

          <!-- Transporte -->
          <div class="detail-section">
            <p class="dialog-p-subtitle">{{ i18nValues['transport'] || 'Transporte' }}</p>
            <el-form-item>
              <span class="label-text">{{ i18nValues['carrierCompany'] || 'Transportista' }}:</span>
              <span class="value-text">{{ movement && movement.transportista ? movement.transportista : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['driver'] || 'Chofer' }}:</span>
              <span class="value-text">{{ movement && movement.chofer ? movement.chofer : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['truckPlate'] || 'Patente' }}:</span>
              <span class="value-text">{{ movement && movement.patente ? movement.patente : "-" }}</span>
            </el-form-item>
          </div>

          <!-- Identificación -->
          <div class="detail-section">
            <p class="dialog-p-subtitle">{{ i18nValues['identification'] || 'Identificación' }}</p>
            <el-form-item>
              <span class="label-text">{{ i18nValues['batch'] || 'Lote' }}:</span>
              <span class="value-text">{{ movement && movement.lote ? movement.lote : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['codePallet'] || 'N° Pallet' }}:</span>
              <span class="value-text">{{ movement && movement.pallet ? movement.pallet : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['numberOfLabel'] || 'N° Etiqueta' }}:</span>
              <span class="value-text">{{ movement && movement.etiqueta ? movement.etiqueta : "-" }}</span>
            </el-form-item>
          </div>

          <!-- Cantidades -->
          <div class="detail-section">
            <p class="dialog-p-subtitle">{{ i18nValues['quantity'] || 'Cantidades' }}</p>
            <el-form-item>
              <span class="label-text">{{ i18nValues['netKg'] || 'KG' }}:</span>
              <span class="value-text">{{ movement && movement.kg ? formatNumber(movement.kg) : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['numberOfBags'] || 'Bags' }}:</span>
              <span class="value-text">{{ movement && movement.bags ? formatNumber(movement.bags) : "-" }}</span>
            </el-form-item>

            <el-form-item>
              <span class="label-text">{{ i18nValues['grossWeight'] || 'Peso Bruto' }}:</span>
              <span class="value-text">{{ movement && movement.pesoBruto ? formatNumber(movement.pesoBruto) : "-" }}</span>
            </el-form-item>
          </div>

          <!-- Comentarios -->
          <div class="detail-section detail-section--full">
            <p class="dialog-p-subtitle">{{ i18nValues['comments'] || 'Comentarios' }}</p>
            <el-form-item>
              <span class="label-text">{{ i18nValues['comments'] || 'Comentarios' }}:</span>
              <span class="value-text">{{ movement && movement.comentarios ? movement.comentarios : "-" }}</span>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </el-card>
  </el-dialog>
</template>

<script>
import { get } from "vuex-pathify";

export default {
  name: "StockMovementDetailModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    movement: {
      type: Object,
      default: null,
    },
  },

  computed: {
    i18nValues: get("i18nStore/valuesRetrieved"),
    modalTitle() {
      if (this.movement) {
        // If it's a silo transaction, prefer a title with the silo name
        if (this.movement.type === "siloTrx") {
          // Try multiple places where silo name might exist in the wrapper
          const siloName = (
            (this.movement.originalData && this.movement.originalData.siloTrx && (this.movement.originalData.siloTrx.silo && (this.movement.originalData.siloTrx.silo.name || this.movement.originalData.siloTrx.silo.code))) ||
            (this.movement.originalData && this.movement.originalData.silo && (this.movement.originalData.silo.name || this.movement.originalData.silo.code)) ||
            // fallback to plantaOrigen which already contains a human readable plant/silo name
            this.movement.plantaOrigen ||
            "-"
          );
          const siloLabel = this.i18nValues['silo'] || 'Silo';
          const titleSilo = this.i18nValues['traceabilityDetail'] || 'Detalle de Trazabilidad';
          return `${titleSilo} - ${siloLabel} - ${siloName}`;
        }
        // Check if it's a loading order
        if (this.movement.type === "loadingOrder" && this.movement.originalData && this.movement.originalData.id) {
          const orderLabel = this.i18nValues['order'] || 'Orden';
          const titleOrder = this.i18nValues['traceabilityDetail'] || 'Detalle de Trazabilidad';
          return `${titleOrder} - ${orderLabel} ${this.movement.originalData.id}`;
        }
        // Check if it has pallet information
        if (this.movement.pallet) {
          const palletLabel = this.i18nValues['pallets'] || 'Pallet';
          const titlePallet = this.i18nValues['traceabilityDetail'] || 'Detalle de Trazabilidad';
          return `${titlePallet} - ${palletLabel} ${this.movement.pallet}`;
        }
      }
      return this.i18nValues['traceabilityDetail'] || 'Detalle de Trazabilidad';
    },
  },

  methods: {
    close() {
      this.$emit("update:visible", false);
    },

    getStatusType(estado) {
      const statusMap = {
        "Disponible": "success",
        "Cargado": "",
        "En Tránsito": "warning",
        "Despachado": "",
        "Excedente": "",
      };
      return statusMap[estado] || "";
    },

    getStatusColor(estado) {
      const colorMap = {
        "Disponible": "#67c23a",
        "Cargado": "#409eff",
        "En Tránsito": "#e6a23c",
        "Despachado": "#909399",
        "Excedente": "#9c27b0",
      };
      return colorMap[estado] || "#909399";
    },

    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      return d.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    formatNumber(num) {
      if (!num) return "-";
      return num.toLocaleString("es-ES");
    },

    getCropName(cultivoVariedad) {
      if (!cultivoVariedad) return "-";
      // Extract crop name (e.g., "Soja" from "Soja PEX-ARG-24")
      const parts = cultivoVariedad.split(" ");
      return parts[0] || "-";
    },

    getVarietyName(cultivoVariedad) {
      if (!cultivoVariedad) return "-";
      // Extract variety name (e.g., "PEX-ARG-24" from "Soja PEX-ARG-24")
      const parts = cultivoVariedad.split(" ");
      return parts.slice(1).join(" ") || "-";
    },
  },
};
</script>

<style scoped>
.custom-dialog /deep/ .el-dialog__body {
  padding: 20px;
}

.custom-dialog /deep/ .el-card {
  border: none;
  box-shadow: none;
}

.custom-dialog /deep/ .el-card__body {
  padding: 20px;
}

.sections-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px 40px;
  margin: 0 auto;
}

.detail-section /deep/ .el-form-item {
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
}

.label-text {
  font-weight: 500;
  font-size: 14px;
  color: #606266;
  flex-shrink: 0;
  width: 110px;
}

.value-text {
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  flex: 1;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin-left: 10px;
}

.detail-section .dialog-p-subtitle {
  margin-bottom: 12px !important;
}

.detail-section--full {
  grid-column: span 2;
}
</style>

